export function getScheduledAppointments(appointments) {
  return appointments.filter(item => item.id !== 'new' && !item.isUnscheduled)
}

export function getUnscheduledAppointments(appointments) {
  return appointments.filter(item => item.id !== 'new' && item.isUnscheduled)
}
